import React from 'react';
import BarChartComponent from "../commons/BarChartComponent";
import PieChartComponent from "../commons/PieChartComponent";


function SingleChoiceChartComponent(props) {

    return (
        <React.Fragment>
            {props.viewType === 'barChart' &&
            <BarChartComponent
                isMobile={props.isMobile}
                chartIndex={props.chartIndex}
                updateChartInfo={props.updateChartInfo}
                chartConfig={props.configuration}
                questionId={props.questionData.question.question_id}
                questionTitle={props.questionData.question.id + ". " + props.questionData.question.question}
                questionChoices={props.questionData.question.choices}
                answersData={props.questionAnswers}
                sortingOptions={props.sortingOptions}
            />}
            {props.viewType === 'pieChart' &&
            <PieChartComponent
                chartIndex={props.chartIndex}
                updateChartInfo={props.updateChartInfo}
                questionId={props.questionData.question.question_id}
                questionTitle={props.questionData.question.id + ". " + props.questionData.question.question}
                chartConfig={props.configuration}
                answersData={props.questionAnswers}
                sortingOptions={props.sortingOptions}
            />}
        </React.Fragment>
    )
}

export default SingleChoiceChartComponent;